window['ThemeTile'] = (link, title) => {
  return {
    hover: false,
    link: link,
    title: title,
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
  };
};
